import fetchwithtoken from '../hooks/fetchwithtoken'
import axios from 'axios'
import { APIPATH, getHeader } from '../utils/utils'
import { APIPATHENV } from '../utils/env'

var JSONbig = require('json-bigint')({ useNativeBigInt: true })

export function signIn(credentials) {
  // credentials.user = credentials.email
  // delete credentials.email
  return new Promise((resolve, reject) => {
    const url = `${APIPATH}user/dashboard/login`
    const method = 'POST'
    const token = null
    fetchwithtoken(url, credentials, token, method)
      .then((res) => {
        if (res.status == 200) {
          return res.text().then((txt) => Promise.resolve(JSONbig.parse(txt)))
        }
        else
          return res.text().then((txt) => Promise.reject(txt))
      })
      .then((data) => {
        localStorage.setItem('access_token', data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)
        resolve(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function BusinessSignIn(token) {
  return new Promise((resolve, reject) => {
    const url = `${APIPATH}business/login`
    const method = 'POST'
    const body = null
    fetchwithtoken(url, body, token, method)
      .then((res) => {
        if (res.status == 200) {
          localStorage.setItem('isBusinessAvailable', true)
          return res.text().then((txt) => Promise.resolve(JSONbig.parse(txt)))
        }
        localStorage.setItem('isBusinessAvailable', false)
        return res.text().then((txt) => Promise.reject(txt))
      })
      .then((data) => {
        if (data) {
          localStorage.setItem('access_token', data.access_token)
          localStorage.setItem('refresh_token', data.refresh_token)
          resolve(data)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function signUp(credentials) {
  return new Promise((resolve, reject) => {
    const url = `${APIPATH}user/register`
    const method = 'POST'
    const token = null
    fetchwithtoken(url, credentials, token, method)
      .then((res) => {
        if (res.status == 201) {
          return res.text().then((txt) => Promise.resolve(JSONbig.parse(txt)))
        }
        reject(res.text().then((txt) => Promise.resolve(JSONbig.parse(txt))))
      })
      .then((data) => {
        resolve(data)
      })
      .catch((error) => {
        localStorage.setItem('access_token', "")
        localStorage.setItem('refresh_token', "")
        reject(error)
      })
  })
}

export function getTokenWithRefreshToken() {
  return new Promise((resolve, reject) => {
    const url = `${APIPATH}business/refresh_token`
    const method = 'POST'
    const token = localStorage.getItem('refresh_token')
    const body = null
    fetchwithtoken(url, body, token, method)
      .then((res) => {
        if (res.status !== 200) {
          reject(null)
        }
        else
          return res.text().then((txt) => Promise.resolve(JSONbig.parse(txt)))
      })
      .then((data) => {
        if (data !== undefined) {
          localStorage.setItem('access_token', data.access_token)
          resolve(data)
        }
        else
          reject(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getUserTokenWithRefreshToken() {
  return new Promise((resolve, reject) => {
    const url = `${APIPATH}user/refresh`
    const method = 'POST'
    const token = localStorage.getItem('refresh_token')
    const body = null
    fetchwithtoken(url, body, token, method)
      .then((res) => {
        if (res.status !== 200) {
          reject(null)
        }
        return res.text().then((txt) => Promise.resolve(JSONbig.parse(txt)))
      })
      .then((data) => {
        if (data !== undefined) {
          localStorage.setItem('access_token', data.access_token)
          resolve(data)
        }
        else
          reject(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function resetPassword(credentials) {
  return new Promise((resolve, reject) => {
    axios.put(APIPATH + 'user/resetpassword', credentials, {
      headers: getHeader()
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        }
        reject(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
